<template>
  <div class="basketball_playerDetail_basePanel">
    <div class="row1">
      <span class="row1_left">
        <span class="row1Left_cloumn1">
          <span
            v-show="!matchInfor.baseInfo.playerLogo"
            class="defaultPlayerLogo"
          ></span>
          <img
            v-show="matchInfor.baseInfo.playerLogo"
            :src="matchInfor.baseInfo.playerLogo"
          />
        </span>
      </span>

      <span class="row1_right">
        <span class="row1Right_row1">
          <span class="row1Right_row1_clo1">
            <span class="row1Right_row1_clo1_row1">
              <!-- <span
                class="playerName"
                v-text="_valPerFormatHandler(matchInfor.baseInfo.playerName)"
              ></span> -->
              <SelectItem
                v-for="selectItem in selectList"
                :key="selectItem.state"
                :options="selectItem"
                :curVal="selectItem.curVal"
                :themeClass="'transparentBg playerDetail_select'"
                @changeValEvent="selectChangeVal"
              ></SelectItem>
            </span>
            <span
              class="row1Right_row1_clo1_row2"
              v-text="
                `${_valPerFormatHandler(
                  matchInfor.baseInfo.shirtNumberWeb
                )} ｜ ${_valPerFormatHandler(
                  matchInfor.baseInfo.positionCodes
                )}`
              "
            ></span>
            <span
              class="row1Right_row1_clo1_row3"
              v-text="_valPerFormatHandler(matchInfor.baseInfo.teamName)"
            ></span>
          </span>
          <span class="row1Right_row1_clo2">
            <span class="row1Right_row1_clo2_clo">
              <span
                v-text="
                  `身高：${_valPerFormatHandler(
                    matchInfor.baseInfo.height,
                    'cm'
                  )}`
                "
              ></span>
              <span
                v-text="
                  `体重：${_valPerFormatHandler(
                    matchInfor.baseInfo.weight,
                    'kg'
                  )}`
                "
              ></span>
              <span
                v-text="
                  `生日：${_valPerFormatHandler(matchInfor.baseInfo.birthDate)}`
                "
              ></span>
            </span>
            <span class="row1Right_row1_clo2_clo">
              <span
                v-text="
                  `国籍：${_valPerFormatHandler(
                    matchInfor.baseInfo.nationality
                  )}`
                "
              ></span>
              <!-- <span v-text="`选秀：${_valPerFormatHandler(matchInfor.baseInfo.nationality)}`"></span> -->
            </span>
            <span class="row1Right_playerScore">
              <span class="playerScore_icon"></span>
              <span class="playerScoreNames">
                <span class="scoreText" v-text="'球员评分'"></span>
                <span
                  class="scoreNum"
                  v-text="_valPerFormatHandler(matchInfor.stat.fantasyPoints)"
                ></span>
              </span>
            </span>
          </span>
        </span>
        <span class="row1Right_row2">
          <span class="row1Right_row2_top">
            <span class="baseDataItem">
              <span class="baseDataItem_text" v-text="'场均得分：'"></span>
              <span
                class="baseDataItem_val"
                v-text="`${_valPerFormatHandler(matchInfor.stat.pointsWeb)}`"
              ></span>
            </span>
            <span class="baseDataItem">
              <span class="baseDataItem_text" v-text="'场均篮板：'"></span>
              <span
                class="baseDataItem_val"
                v-text="`${_valPerFormatHandler(matchInfor.stat.rebounds)}`"
              ></span>
            </span>
            <span class="baseDataItem">
              <span class="baseDataItem_text" v-text="'场均助攻：'"></span>
              <span
                class="baseDataItem_val"
                v-text="`${_valPerFormatHandler(matchInfor.stat.assists)}`"
              ></span>
            </span>
            <span class="baseDataItem">
              <span class="baseDataItem_text" v-text="'场均盖帽：'"></span>
              <span
                class="baseDataItem_val"
                v-text="`${_valPerFormatHandler(matchInfor.stat.blocks)}`"
              ></span>
            </span>
            <span class="baseDataItem">
              <span class="baseDataItem_text" v-text="'场均抢断：'"></span>
              <span
                class="baseDataItem_val"
                v-text="`${_valPerFormatHandler(matchInfor.stat.steals)}`"
              ></span>
            </span>
            <span class="baseDataItem">
              <span class="baseDataItem_text" v-text="'场均失误：'"></span>
              <span
                class="baseDataItem_val"
                v-text="`${_valPerFormatHandler(matchInfor.stat.turnovers)}`"
              ></span>
            </span>
          </span>
          <span class="row1Right_row2_bottom"></span>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
import SelectItem from '@components/platfromBase/basketball/selectItem.vue'
export default {
  name: 'basketball_playerDetail_basePanel',
  mixins: [cup_base_data_mixin],
  components: { SelectItem },
  props: {
    matchInfor: {
      type: Object,
      default: () => ({
        baseInfo: {},
        stat: {},
        players: [],
      }),
    },
    playerList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      matchStatusNameArr: [
        '未开始',
        '进行中',
        '取消',
        '已完赛',
        '延期',
        '待定',
      ],
      selectList: [
        {
          list: [],
          keyValArr: ['id', 'name'],
          placeholder: '请选择',
          isFilterable: false,
          widthVw: 9.74,
          curVal: '',
          state: 'playerName',
        },
      ],
      curSelect_playerName: '',
    }
  },
  watch: {
    matchInfor: {
      handler(newVal, oldVal) {
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          console.debug(
            'basketball_playerDetail_basePanel 重新刷新数据:',
            newVal,
            oldVal
          )
          this.selectList = [
            {
              list: newVal.players.map((item) => {
                return {
                  id: item.playerId + '',
                  name: item.playerName,
                }
              }),
              keyValArr: ['id', 'name'],
              placeholder: '请选择',
              isFilterable: false,
              widthVw: 9.74,
              curVal: '',
              state: 'playerName',
            },
          ]
          this.curSelect_playerName = newVal.baseInfo.playerId + ''
          this.initSelectOpt()
        }
      },
      //   immediate: true,
      deep: true,
    },
  },
  created() {
    // this.selectList = [
    //     {
    //       list: this.,
    //       keyValArr: ['id', 'name'],
    //       placeholder: '请选择',
    //       isFilterable: false,
    //       widthVw: 9.74,
    //       curVal: '',
    //       state: 'playerName',
    //     },
    //   ]
  },
  methods: {
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
    initSelectOpt() {
      let selectList = JSON.parse(JSON.stringify(this.selectList))
      this.selectList = selectList.map((item) => {
        if (item) {
          item.curVal = this[`curSelect_${item.state}`]
        }
        return item
      })
    },
    selectChangeVal(data) {
      console.debug('selectChangeVal:', data)
      // if (data.state === 'playerName') {
      //   this.curSelect_playerName = data.val
      // }
      this.$emit('selectChangeVal', data)
    },
  },
}
</script>

<style lang="scss" scoped>
.basketball_playerDetail_basePanel {
  position: relative;
  height: 16.875vw;
  width: 100%;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .row1 {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: flex-end;
    .row1_left,
    .row1_right {
      display: flex;
      display: -webkit-flex;
      align-items: center;
    }
    .row1_left {
      position: absolute;
      left: 0;
      bottom: 0;
      z-index: 10;
      width: 9.91vw;
      height: 13.88vw;
      justify-content: flex-start;
      .row1Left_cloumn1 {
        display: block;
        width: 100%;
        height: 100%;
        border-radius: 0.416vw;
        overflow: hidden;
        .defaultPlayerLogo {
          display: block;
          width: 100%;
          height: 100%;
          background-image: var(--mixtmt_default_playerLogo);
          background-repeat: no-repeat;
          background-position: center bottom;
          background-size: cover;
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
    .row1_right {
      width: 100%;
      justify-content: flex-end;
      flex-direction: column;
      .row1Right_row1 {
        padding-left: calc(12.5vw - 0.694vw);
        width: 100%;
        height: 10.416vw;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        color: var(--mixtmt_whiteColor);
        .row1Right_row1_clo1 {
          position: relative;
          width: 11.1vw;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          flex-direction: column;
          &::before {
            position: absolute;
            content: '\20';
            right: 0;
            top: 0;
            z-index: 2;
            width: 1px;
            height: 100%;
            background-color: var(--mixtmt_whiteColor);
          }
          .row1Right_row1_clo1_row1 {
            width: 100%;
            max-height: 3.36vw;
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
          }
          .row1Right_row1_clo1_row2 {
            width: 100%;
            padding-left: 0.694vw;
            font-size: 1.11vw;
            line-height: 2.25vw;
          }
          .row1Right_row1_clo1_row3 {
            width: 100%;
            padding-left: 0.694vw;
            font-size: 0.974vw;
            line-height: 1.38vw;
          }
        }
        .row1Right_row1_clo2 {
          position: relative;
          width: calc(100% - 9.74vw);
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: flex-start;

          .row1Right_row1_clo2_clo {
            padding-left: 3.47vw;
            width: 13.21vw;
            height: 100%;
            display: flex;
            display: -webkit-flex;
            justify-content: space-evenly;
            align-items: flex-start;
            flex-direction: column;
            & > span {
              width: 100%;
              font-size: 1.11vw;
              line-height: 2.083vw;
            }
          }
        }
      }
      .row1Right_row2 {
        position: relative;
        width: 100%;
        height: 3.88vw;
        .row1Right_row2_top {
          position: absolute;
          top: 0;
          left: calc(9.91vw + 1.388vw);
          z-index: 2;
          width: calc(100% - 9.91vw - 1.388vw);
          height: 100%;
          display: flex;
          display: -webkit-flex;
          justify-content: space-evenly;
          align-items: center;
          .baseDataItem {
            flex: 1;
            color: var(--mixtmt_whiteColor);
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            .baseDataItem_text,
            .baseDataItem_val {
              width: auto;
              font-size: 1.11vw;
              line-height: 2.778vw;
            }
          }
        }
        .row1Right_row2_bottom {
          display: block;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            270deg,
            rgba(36, 100, 181, 0.31) 0%,
            #3656a0 29%,
            #3656a0 100%
          );
          opacity: 0.7;
          border-radius: 1vw 0 0 1vw;
        }
      }
      .row1Right_playerScore {
        position: absolute;
        right: 0;
        top: 0;
        z-index: 2;
        width: auto;
        padding: 0 1.11vw;
        display: flex;
        display: -webkit-flex;
        align-items: center;
        justify-content: center;
        .playerScoreNames {
          padding-left: 1.11vw;
          width: auto;
          display: flex;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          color: var(--mixtmt_whiteColor);
          .scoreText {
            font-size: 1.11vw;
          }
          .scoreNum {
            font-size: 2.083vw;
            font-weight: bold;
          }
        }
        .playerScore_icon {
          width: 2.63vw;
          height: 3.62vw;
          background-image: var(--mixtmt_playerDetail_playerScore_icon);
          background-size: 100% auto;
          background-repeat: no-repeat;
          background-position: center;
        }
      }
    }
  }
}

.mixtmt_pc .basketball_playerDetail_basePanel {
}
</style>
